import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { debounce, find } from 'lodash'
import moment from 'moment'

import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box'
import Select from '@material-ui/core/Select'
import Checkbox from '@material-ui/core/Checkbox'
import { withStyles } from '@material-ui/core'
import Typography from '@material-ui/core/Typography'
import Popover from '@material-ui/core/Popover'
import MenuItem from '@material-ui/core/MenuItem'
import { Search, ExpandMore } from '@material-ui/icons';
import TextFiled from '@/components/textField';
import { Colors } from '@/theme';
import Button from '@/components/button';
import Paper from '@material-ui/core/Paper';
import Calendar from 'react-calendar'

import { EXPENSE_PAYMENT_STATUSES, EXPENSE_STATUSES } from '../helper'
import useStyles from './styles';

const FormHeader = (props) => {
  const classes = useStyles();
  const { t } = useTranslation();

  const {
    expenseStatuses,
    expensePaymentStatuses,
    dateRange,
    onChangeExpenseStatuses,
    onChangeExpensePaymentStatuses,
    onChangeDateRange,
    onChangeSearch,
    onAdd
  } = props

  const [datePickerAnchor, setDatePickerAnchor] = useState(null)

  return (
    <Grid item xs={12}>
      <Paper style={{ width: '100%' }}>
        <Grid
          container
          alignItems='center'
          spacing={2}
          className={classes.paperContent}
        >
          <Grid item xs={12} sm={4} lg={4}>
            <TextFiled
              placeholder={t('expenses.enter_payee_name')}
              className={classes.searchInput}
              onChange={debounce((e) => onChangeSearch(e.target.value), 1000)}
              startAdornment={
                <Search
                  style={{ color: Colors.GRAY_BORDER1 }}
                  width={18}
                  height={18}
                />
              }
            />
          </Grid>

          <Grid item xs={12} sm={4} lg={2} style={{ padding: '4px 12px' }}>
            <Select
              multiple
              disableUnderline
              IconComponent={ExpandMore}
              displayEmpty
              renderValue={() => expensePaymentStatuses.length === EXPENSE_PAYMENT_STATUSES.length
                ? t('expenses.all_expenses')
                : expensePaymentStatuses.map(item => item.name).join(', ')
              }
              fullWidth
              className={classes.filterInput}
              value={expensePaymentStatuses}
              onChange={(event) => onChangeExpensePaymentStatuses(event.target.value)}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {EXPENSE_PAYMENT_STATUSES.map((item, id) => (
                <MenuItem key={`order-payment-state-${id}`} value={item}>
                  <GreenCheckbox
                    color='default'
                    checked={!!find(expensePaymentStatuses, { state: item.state })}
                    size='small'
                  />
                  <Typography className={classes.titleText}>
                    {item.name}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={4} lg={2} style={{ padding: '4px 12px' }}>
            <Select
              multiple
              disableUnderline
              IconComponent={ExpandMore}
              displayEmpty
              renderValue={() => expenseStatuses.length === EXPENSE_STATUSES.length
                ? t('expenses.all_status')
                : expenseStatuses.map(item => item.name).join(', ')
              }
              fullWidth
              className={classes.filterInput}
              value={expenseStatuses}
              onChange={(event) => onChangeExpenseStatuses(event.target.value)}
              inputProps={{ 'aria-label': 'Without label' }}
            >
              {EXPENSE_STATUSES.map((item, id) => (
                <MenuItem key={`order-state-${id}`} value={item}>
                  <GreenCheckbox
                    color='default'
                    checked={!!find(expenseStatuses, { state: item.state })}
                    size='small'
                  />
                  <Typography className={classes.titleText}>
                    {item.name}
                  </Typography>
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item xs={12} sm={4} lg={2} style={{ padding: '4px 12px' }}>
            <Box
              className={classes.selectContainer}
              onClick={(e) => setDatePickerAnchor(e.currentTarget)}
            >
              <Typography className={classes.filterInput}>
                {
                  moment().isSame(moment(dateRange[0]), 'day') && moment().isSame(moment(dateRange[1]), 'day')
                    ?
                    t('expenses.today')
                    :
                    moment(dateRange[0]).format('DD/MM/YY') + ' - ' + moment(dateRange[1]).format('DD/MM/YY')
                }
              </Typography>
              <ExpandMore fontSize='default' className={classes.expandIcon} />
            </Box>
          </Grid>

          <Grid item xs={12} sm={8} lg={2}>
            <Grid container justify="flex-end">
              <Button
                className={classes.addButton}
                color="primary"
                variant="contained"
                onClick={onAdd}
              >
                {t('button_group.add_new')}
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Paper>

      <Popover
        id='simple-popover'
        open={Boolean(datePickerAnchor)}
        anchorEl={datePickerAnchor}
        onClose={() => setDatePickerAnchor(null)}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
      >
        <Calendar
          value={dateRange}
          onChange={(value) => {
            onChangeDateRange(value)
            setDatePickerAnchor(null)
          }}
          showDoubleView
          selectRange
        />
      </Popover>
    </Grid>
  );
};

const GreenCheckbox = withStyles({
  root: {
    color: '#979797',
    '&$checked': {
      color: '#55CC66',
    },
  },
  checked: {},
})((props) => <Checkbox color="default" {...props} />);

export default FormHeader;
